export default "__VITE_ASSET__D1rTJBNw__"